var app = angular.module('leonardo');

var DeleteTasksFilters = function(
  $scope,
  $controller
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filterService.setFilter('only_status_pending', true);
  $scope.filterService.setFilter('include_workflow_and_unit_workflow_tasks', true);
  $scope.filterService.setFilter('include_document_tasks', true);
  $scope.filterService.setFilter('include_personal_tasks', true);

  $scope.filterService.setFilter('filters', [
    'only_status_pending',
    'include_workflow_and_unit_workflow_tasks',
    'include_document_tasks' ,
    'include_personal_tasks'
  ]);

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'date_from',
      name: 'From Date',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'From Date',
      condition: true,
      conflicts: [],
      positionVertical: 'bottom',
      endDate: 'date_to'
    },
    {
      id: 'date_to',
      name: 'To Date',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'To Date',
      condition: true,
      conflicts: [],
      positionVertical: 'bottom',
      startDate: 'date_from'
    },
    {
      id: 'only_status_pending',
      name: 'Only status pending',
      label: null,
      inline: false,
      type: 'checkbox',
      condition: true,
      conflicts: []
    },
    {
      id: 'include_workflow_and_unit_workflow_tasks',
      name: 'Include workflow and unit workflow tasks',
      label: null,
      inline: false,
      type: 'checkbox',
      condition: true,
      conflicts: []
    },
    {
      id: 'include_document_tasks',
      name: 'Include documents tasks',
      label: null,
      inline: false,
      type: 'checkbox',
      condition: true,
      conflicts: []
    },
    {
      id: 'include_personal_tasks',
      name: 'Include personal tasks',
      type: 'checkbox',
      condition: true,
      conflicts: []
    }
  ];

};

app.controller('DeleteTasksFilters', [
  '$scope',
  '$controller',
  DeleteTasksFilters
]);
